export default __webpack_public_path__ + "static/media/Inventory.6a6c32df.png";